<template>
    <div class="team-stats">
        <div class="team-section-title">
            <span class="team-section-title__bar custom-orange" />
            Ομαδικά στατιστικά
            <v-btn-toggle v-model="option" mandatory class="stats-toggle">
                <v-btn :value="0" small class="stats-toggle__btn">Μέσοι όροι</v-btn>
                <v-btn :value="1" small class="stats-toggle__btn">Σύνολο</v-btn>
            </v-btn-toggle>
        </div>
        <div class="team-tiles">
            <div v-for="stat in mainStats" :key="stat.value" class="team-tile">
                <v-icon small color="orange">{{ stat.icon }}</v-icon>
                <span class="team-tile__value">{{ displayValue(stat) }}</span>
                <span class="team-tile__label">{{ stat.label }}</span>
            </div>
        </div>
        <!-- where the points came from -->
        <div class="team-tiles-title">Πηγή πόντων</div>
        <div class="team-tiles team-tiles--sources">
            <div v-for="stat in sourceStats" :key="stat.value" class="team-tile">
                <v-icon small color="orange">{{ stat.icon }}</v-icon>
                <span class="team-tile__value">{{ displayValue(stat) }}</span>
                <span class="team-tile__label">{{ stat.label }}</span>
            </div>
        </div>

        <div class="team-section-title">
            <span class="team-section-title__bar custom-orange" />
            Παίκτες
        </div>
        <players-stats :players="players" :option="option" class="px-0" />

        <div class="team-section-title">
            <span class="team-section-title__bar custom-orange" />
            Απόδοση ανά περίοδο
        </div>
        <player-period-heatmap :players="players" :option="option" />
        <team-period-heatmap :players="players" />
        <team-period-heatmap :players="players" conceded />
    </div>
</template>

<script>
    import PlayersStats from '@/components/PlayersStats'
    import PlayerPeriodHeatmap from '@/components/PlayerPeriodHeatmap'
    import TeamPeriodHeatmap from '@/components/TeamPeriodHeatmap'
    export default {
        components: { PlayersStats, PlayerPeriodHeatmap, TeamPeriodHeatmap },
        props: {
            players: {
                type: Array,
                default: null
            },
            matchesPlayed: {
                type: Number,
                default: 1
            },
            type: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                option: 0,
                stats: [
                    { value: 'points', label: 'Πόντοι', icon: 'mdi-basketball', total: 0 },
                    { value: 'rebounds', label: 'Ριμπάουντ', icon: 'mdi-basketball-hoop-outline', total: 0 },
                    { value: 'assists', label: 'Ασίστ', icon: 'mdi-handshake-outline', total: 0 },
                    { value: 'steals', label: 'Κλεψίματα', icon: 'mdi-hand-back-left-outline', total: 0 },
                    { value: 'turnovers', label: 'Λάθη', icon: 'mdi-alert-circle-outline', total: 0 },
                    { value: 'blockedShots', label: 'Κοψίματα', icon: 'mdi-cancel', total: 0 },
                    { value: 'assistPoints', label: 'Από ασίστ', icon: 'mdi-handshake', total: 0, source: true },
                    { value: 'secondChancePoints', label: 'Δεύτερης ευκαιρίας', icon: 'mdi-replay', total: 0, source: true },
                    { value: 'pointsOffTurnovers', label: 'Από λάθη αντιπάλου', icon: 'mdi-swap-horizontal-bold', total: 0, source: true }
                ]
            }
        },
        computed: {
            mainStats() {
                return this.stats.filter(stat => !stat.source)
            },
            sourceStats() {
                return this.stats.filter(stat => stat.source)
            }
        },
        watch: {
            players: {
                handler() {
                    this.getTotalTeam()
                },
                deep: true
            }
        },
        created() {
            this.getTotalTeam()
        },
        methods: {
            getTotalTeam() {
                this.stats.forEach(stat => {
                    stat.total = 0
                    this.players.forEach(player => {
                        player.stats.forEach(match => {
                            stat.total += Number(match[stat.value]) || 0
                        })
                    })
                })
            },
            displayValue(stat) {
                if (this.option === 0) {
                    return this.matchesPlayed > 0 ? (stat.total / this.matchesPlayed).toFixed(1) : '-'
                }
                return stat.total
            }
        }
    }
</script>

<style scoped>
.team-stats {
    font-family: Ubuntu, Arial, sans-serif;
    text-align: left;
}

.team-section-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin: 20px 0 12px;
    padding: 8px 14px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-size: 1.1rem;
    font-weight: 800;
}

.team-section-title:first-child {
    margin-top: 0;
}

.team-section-title__bar {
    width: 5px;
    height: 20px;
    border-radius: 2px;
}

.team-tiles {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 10px;
}

.team-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 12px 6px;
    border-radius: 10px;
    background: #fff;
    border-top: 3px solid #ff7133;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.team-tile__value {
    font-size: 1.6rem;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
}

.team-tile__label {
    color: rgba(0, 0, 0, 0.55);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

/* ---------- Toggle (same look as the filters bar) ---------- */
.stats-toggle {
    margin-left: auto;
    background: #0d0d0f !important;
    border-radius: 8px !important;
    padding: 3px;
}

.stats-toggle .stats-toggle__btn {
    background: transparent !important;
    border: none !important;
    border-radius: 6px !important;
    color: rgba(255, 255, 255, 0.75) !important;
    font-weight: 700;
    text-transform: none;
    letter-spacing: normal;
    height: 28px !important;
    font-size: 0.75rem;
}

.stats-toggle .stats-toggle__btn.v-btn--active {
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 50%, orange 100%) !important;
    color: #fff !important;
}

.stats-toggle .stats-toggle__btn.v-btn--active::before {
    opacity: 0 !important;
}

.team-tiles--sources {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

/* a label of its own: the page background is a busy image */
.team-tiles-title {
    display: inline-block;
    margin: 14px 0 8px;
    padding: 4px 12px;
    background: #fff;
    border-left: 4px solid #ff7133;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    color: rgba(0, 0, 0, 0.75);
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

@media (max-width: 960px) {
    .team-tiles {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .team-tile__value {
        font-size: 1.25rem;
    }

    .stats-toggle {
        margin-left: 0;
    }
}
</style>
